import React, { useState } from "react";
import {
  Container,
  SwipeableDrawer,
  Box,
  Typography,
  FormControlLabel,
  Checkbox,
  Link,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Button from "../Button/Button";
import FacebookIcon from "../../../assets/images/facebookIcon.png";
import useMediaQuery from "@mui/material/useMediaQuery";
import GoogleIcon from "../../../assets/images/googleIcon.png";
import Machine1 from "../../../assets/images/machine1.png";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EmailIcon from "../../../assets/images/emailIcon.png";

import ReactCountryFlag from "react-country-flag";
import Fi from "../Field/Fi";
import SocialButtons from "../SocialButtons/SocialButtons";

function BottomLoginModalPLP({ open, toggleDrawer }) {
  const [ForgotPass, setForgotPass] = useState(false);
  const mobMatch = useMediaQuery("(max-width:600px)");
  const [CreateAcc, setCreateAcc] = useState(false);

  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      onClose={() => toggleDrawer(false)}
      PaperProps={{
        sx: {
          boxShadow:
            "0px -8px 10px rgba(0, 0, 0, 0.14), 0px -3px 14px rgba(0, 0, 0, 0.12), 0px -5px 5px rgba(0, 0, 0, 0.2)",
          height: "100%",
        },
      }}
    >
      <Box
        sx={{
          padding: "24px 16px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            margin: "6px 0px 26px",
            width: "100%",
          }}
        >
          <ArrowBackIcon
            sx={{ cursor: "pointer", color: "primary.main" }}
            onClick={() => {
              if (ForgotPass) {
                setForgotPass(false);
              } else if (CreateAcc) {
                setCreateAcc(false);
              } else {
                toggleDrawer(false);
              }
            }}
          />
        </Box>
        {!CreateAcc ? (
          <Container disableGutters={true}>
            <Box>
              <Typography
                variant="h3"
                sx={{ fontSize: "22px", fontWeight: "600", lineHeight: "26px" }}
              >
                {ForgotPass ? "Forgot Password?" : "Login to continue"}
              </Typography>
              {!ForgotPass && (
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: "16px",
                    lineHeight: "24px",
                    color: "#616161",
                    marginTop: "8px",
                  }}
                >
                  So we can keep you up-to-date with your purchase.
                </Typography>
              )}
            </Box>
            <Container
              sx={{
                display: "flex",
                marginTop: "32px",
              }}
              disableGutters={true}
            >
              <Box
                sx={{
                  display: "flex",
                  width: "100%",
                }}
              >
                <Box sx={{ width: "100%" }}>
                  {!ForgotPass && (
                    <Typography
                      variant="subtitle1"
                      sx={{
                        fontSize: "16px",
                        lineHeight: "24px",
                        fontWeight: "600",
                        marginBottom: "16px",
                      }}
                    >
                      {"Already have an account?"}
                    </Typography>
                  )}
                  <Box sx={{ width: "100%" }}>
                    <Fi
                      label="Email Address"
                      size="small"
                      height="48px"
                      sx={{ marginBottom: "24px", width: "100%" }}
                    />
                    {!ForgotPass ? (
                      <Fi
                        label="Password"
                        size="small"
                        height="48px"
                        sx={{ marginBottom: "24px", width: "100%" }}
                      />
                    ) : (
                      ""
                    )}
                    <Button
                      bgColor="#F9D548"
                      txColor="text.primary"
                      typoVariant="subtitle1"
                      typoSize="16px"
                      fontWeight="600"
                      hoverBg="#F3C04F"
                      sx={{
                        width: "100%",
                        height: "48px",
                        maxWidth: "100%",
                        marginBottom: "24px",
                      }}
                    >
                      {ForgotPass ? "Send instructions" : "Login"}
                    </Button>
                    <Link
                      onClick={() => {
                        setForgotPass(!ForgotPass);
                      }}
                      sx={{ cursor: "pointer" }}
                      underline="none"
                      color="#255CCE"
                    >
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontSize: "14px",
                          lineHeight: "20px",
                          fontWeight: "600",
                        }}
                      >
                        {ForgotPass ? "Back to Login" : "Forgot password?"}
                      </Typography>
                    </Link>
                  </Box>
                  {!ForgotPass && (
                    <Box
                      sx={{
                        display: "flex",
                        flexFlow: "column",
                        rowGap: "24px",
                        marginTop: "24px",
                        width: "100%",
                      }}
                    >
                      <SocialButtons
                        icon={FacebookIcon}
                        text="Login with Facebook"
                        sx={{ width: "100%" }}
                      />
                      <SocialButtons
                        sx={{ width: "100%" }}
                        icon={GoogleIcon}
                        text="Sign In with Google"
                      />
                    </Box>
                  )}
                  {!ForgotPass && (
                    <Typography
                      variant="subtitle2"
                      sx={{
                        textAlign: "center",
                        fontSize: "14px",
                        lineHeight: "20px",
                        fontWeight: "600",
                        color: "#255CCE",
                        marginY: "32px",
                      }}
                    >
                      Not registered yet?
                      <Link onClick={() => setCreateAcc(true)} color="#255CCE">
                        Create account
                      </Link>
                    </Typography>
                  )}
                </Box>
              </Box>
            </Container>
          </Container>
        ) : (
          <Box>
            <Typography
              variant="subtitle1"
              sx={{
                fontSize: "16px",
                lineHeight: "24px",
                fontWeight: "600",
                marginBottom: "16px",
              }}
            >
              Create new account
            </Typography>
            <Box>
              <Fi
                label="Full Name"
                size="small"
                height="48px"
                sx={{ marginBottom: "24px", width: "100%" }}
              />
              <Fi
                label="Email address"
                size="small"
                height="48px"
                sx={{ marginBottom: "24px", width: "100%" }}
              />
              <Box
                sx={{
                  marginBottom: "24px",
                  display: "flex",
                  width: "100%",
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "25%",
                    height: "47.4px",
                    backgroundColor: "#F5F5F5",
                    border: "1px solid #BFBFBF",
                    borderRight: "none",
                    borderRadius: "3px 0 0 3px",
                  }}
                >
                  <ReactCountryFlag countryCode="AE" svg />
                  <Typography
                    variant="body1"
                    fontFamily="Inter"
                    fontSize="16px"
                    fontWeight="400"
                    lineHeight="24px"
                    color="primary.main"
                    sx={{ marginLeft: "5px" }}
                  >
                    +971
                  </Typography>
                </Box>
                <Fi
                  sx={{
                    width: "75%",
                    height: "46.29px",
                  }}
                  inputPropsSx={{
                    borderRadius: "0 3px 3px 0",
                  }}
                  label="Phone Number"
                  size="small"
                  height="48px"
                />
              </Box>
              <Fi
                label="Company Name"
                size="small"
                height="48px"
                sx={{ marginBottom: "24px", width: "100%" }}
              />
              <Fi
                label="Password"
                size="small"
                height="48px"
                sx={{ marginBottom: "24px", width: "100%" }}
              />
              <Fi
                label="Confirm Password"
                size="small"
                height="48px"
                sx={{ marginBottom: "24px", width: "100%" }}
              />

              <FormControlLabel
                sx={{ alignItems: "start", display: "flex", margin: "0px" }}
                control={
                  <Checkbox
                    sx={{ width: "24px", height: "24px" }}
                    defaultChecked
                  />
                }
                label={
                  <Typography
                    variant="body2"
                    sx={{ fontSize: "14px", lineHeight: "20px" }}
                  >
                    Check here to indicate that you have read and agree to the
                    terms and conditions of the{" "}
                    <a
                      href="?"
                      style={{ color: "#255CCE", textDecoration: "none" }}
                    >
                      Machinery Planet's Pro agreement.
                    </a>
                  </Typography>
                }
              />

              <Button
                bgColor="#F9D548"
                txColor="text.primary"
                typoVariant="subtitle1"
                typoSize="16px"
                fontWeight="600"
                hoverBg="#F3C04F"
                sx={{
                  marginTop: "24px",
                  width: "100%",
                  height: "48px",
                  marginBottom: "24px",
                }}
              >
                Register
              </Button>
            </Box>
          </Box>
        )}
      </Box>
    </SwipeableDrawer>
  );
}

export default BottomLoginModalPLP;
